import * as React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import Pagination from "../components/pagination";
import { Box, Button, Divider, Flex, Heading, Icon } from "@chakra-ui/react";
import { RepeatClockIcon } from "@chakra-ui/icons";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Seo from "../components/seo";

const CategoryTemplate = ({ data, pageContext }) => {
  const { category } = pageContext;
  return (
    <Layout>
      <Box
        as="h1"
        textAlign={"center"}
        fontWeight={"bold"}
        m={5}
        fontSize={"xl"}
      >
        【{new Date().toLocaleDateString()}】Amazonの{category}おすすめ商品
        {pageContext.totalCount}選
      </Box>
      <Box>
        当サイトでは、Amazonの豊富な品揃えの中から、ユーザーの満足度が高い
        {category}
        おすすめ商品を{pageContext.totalCount}
        選ご紹介しています。口コミ評価や詳細な解説を通じて、お買い物に役立つ情報を提供します。ぜひお気に入りの商品を見つけてください！
      </Box>
      {data.allGoogleAmazonRecommendSheet.nodes.map((node, index) => {
        return (
          <Box key={index}>
            <Divider color={"gray.800"} />
            <Flex m={2} align={"center"}>
              <Icon as={RepeatClockIcon} />
              <Box mx={2}>{node.updatedAt}時点</Box>
            </Flex>
            <Heading as="h2" size="md" mb={5}>
              {node.title}
            </Heading>
            <GatsbyImage image={getImage(node.childFile)} alt={node.title} />
            {node.aiDescription && (
              <Box my={5} whiteSpace="pre-line">
                {node.aiDescription}
              </Box>
            )}
            {node.aiRecommendPoint && (
              <Box
                m={2}
                whiteSpace="pre-line"
                borderWidth="2px"
                borderRadius="lg"
                borderColor="orange.400"
                p={2}
              >
                {node.aiRecommendPoint}
              </Box>
            )}
            <Box m={2} textAlign="center">
              <a href={node.url} target="_blank" rel="noopener noreferrer">
                <Button bg="orange.400" width="100%" fontSize={"2xl"}>
                  Amazonで見る
                </Button>
              </a>
            </Box>
          </Box>
        );
      })}
      <Pagination
        currentPage={pageContext.currentPage}
        maxPage={pageContext.maxPage}
        pagePath={`/category/${category}`}
      />
    </Layout>
  );
};

export default CategoryTemplate;

export const Head = ({ data, pageContext }) => {
  const publicURL =
    data.allGoogleAmazonRecommendSheet.nodes[0].childFile.publicURL;
  return (
    <Seo
      title={`【${new Date().toLocaleDateString()}】Amazonの${
        pageContext.category
      }おすすめ商品${pageContext.totalCount}選`}
      description={`当サイトでは、Amazonの豊富な品揃えの中から、ユーザーの満足度が高い${pageContext.category}おすすめ商品を${pageContext.totalCount}選ご紹介しています。口コミ評価や詳細な解説を通じて、お買い物に役立つ情報を提供します。ぜひお気に入りの商品を見つけてください！`}
      imgPath={publicURL}
    />
  );
};

export const query = graphql`
  query ($category: String!, $skip: Int!, $limit: Int!) {
    allGoogleAmazonRecommendSheet(
      filter: { group: { eq: $category } }
      sort: { fields: group, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        id
        title
        url
        childFile {
          publicURL
          childImageSharp {
            gatsbyImageData(height: 300, layout: CONSTRAINED)
          }
        }
        price
        aiDescription
        aiRecommendPoint
        group
        updatedAt
      }
    }
  }
`;
